var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
// sections/PlaceholderSection.tsx
export default function PlaceholderSection(_a) {
    var label = _a.label;
    return (_jsxs("div", __assign({ className: "p-4 text-gray-400 italic" }, { children: [label, " \u2014 \u00E0 impl\u00E9menter"] })));
}
